var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPrintIcon = function SvgPrintIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icons8-print_1_",
    "data-name": "icons8-print (1)",
    d: "M10.25,5A2.261,2.261,0,0,0,8,7.25V8H7.25A3.262,3.262,0,0,0,4,11.25v7A2.261,2.261,0,0,0,6.25,20.5H8v1.25A2.261,2.261,0,0,0,10.25,24h7.5A2.261,2.261,0,0,0,20,21.75V20.5h1.75A2.261,2.261,0,0,0,24,18.25v-7A3.262,3.262,0,0,0,20.75,8H20V7.25A2.261,2.261,0,0,0,17.75,5Zm0,1.5h7.5a.739.739,0,0,1,.75.75V8h-9V7.25A.739.739,0,0,1,10.25,6.5Zm-3,3h13.5a1.739,1.739,0,0,1,1.75,1.75v7a.739.739,0,0,1-.75.75H20V17.25A2.261,2.261,0,0,0,17.75,15h-7.5A2.261,2.261,0,0,0,8,17.25V19H6.25a.739.739,0,0,1-.75-.75v-7A1.739,1.739,0,0,1,7.25,9.5Zm3,7h7.5a.739.739,0,0,1,.75.75v4.5a.739.739,0,0,1-.75.75h-7.5a.739.739,0,0,1-.75-.75v-4.5A.739.739,0,0,1,10.25,16.5Z",
    transform: "translate(-4 -5)",
    fill: "#2a3c50"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPrintIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/printIcon.2b11a70a.svg";
export { ForwardRef as ReactComponent };